<template>
  <div>
    <b-form-group
        label-for="input-6"
        class="custom-label"
    >
      <label-info
          id="popover-target-medication-name"
          label-name="What is the goal of this Exercise Plan?"
          label-info="Please feel free to enter as much as possible in plain text. This will allow our AI enginer provide for your needs."
      />
      <b-dropdown
          id="dropdown-header"
          text="Select Goals"
          block
          variant="primary"
          split
          split-variant="outline-primary"
          class="m-2"
          menu-class="w-100"
          @hidden="handleDropDownClosed"
      >
        <template #button-content>
           <span
               v-if="exerciseGoalTxt"
           >
             {{exerciseGoalTxt}}
           </span>
          <strong v-else>
            Add Goal
          </strong>
        </template>
        <b-dropdown-form>
          <b-form-textarea
              id="textarea"
              v-model="exerciseGoalTxt"
              placeholder="or enter text.."
              rows="3"
              max-rows="6"
              style="margin-bottom: 15px"
          />
        </b-dropdown-form>
        <b-dropdown-header id="dropdown-header-label">
          - OR SELECT-
        </b-dropdown-header>
        <b-dropdown-form
            v-for="(aGoal, i) in exerciseGoals"
            aria-describedby="dropdown-header-label"
            :key="`exercise-goal-${i}`"
        >
          <toggle-single
              :id="aGoal.key"
              :label-name="aGoal.text"
              :label-info="aGoal.description"
              :toggle-model="toggleModels[aGoal.key]"
              @toggle-click="handleToggleClick(aGoal.key)"
          />
        </b-dropdown-form>
      </b-dropdown>

      <pre class="mt-3 mb-0">{{ selectedExerciseGoals }}</pre>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/blockResources/_components/labelInfo";
import ToggleSingle from "@/components/blockResources/_components/toggleSingle";
import bendExerciseOptionsJSON from "../../../assets/json/bendExerciseOptions.json";
export default {
  name: "Bend_ExerciseGoals",
  components: {
    LabelInfo,
    ToggleSingle
  },
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData"
    }),
  },
  mounted(){
    this.setExerciseGoals();
  },
  methods: {
    handleToggleClick(toggleModelKey){
      debugger;
      this.toggleModels[toggleModelKey] = true; //!this.toggleModels[toggleModelKey];
      //this.toggleModels = this.toggleModels;
    },
    setExerciseGoals(){
      this.exerciseGoals =  this.bendExerciseOptionsJSON && Array.isArray(this.bendExerciseOptionsJSON.exercise_goals) ? this.bendExerciseOptionsJSON.exercise_goals :[];

       //set toggle object
       if(this.exerciseGoals && Array.isArray(this.exerciseGoals)){
         this.exerciseGoals.forEach((aGoal)=>{
           this.$set(this.toggleModels, aGoal.key, false);
         });
       }
      },
    handleDropDownClosed(){
      debugger;
      if(this.exerciseGoalTxt && this.exerciseGoalTxt.length > 0 ){
        this.$emit('add-goal', this.exerciseGoalTxt);
      }
    }
  },
  data() {
    return {
      toggleModels: {},
      exerciseGoalTxt: null,
      bendExerciseOptionsJSON,
      selectedExerciseGoals:'',
      exerciseGoals: null
    };
  }
};
</script>

<style lang="scss" scoped></style>
